import translit from '@/tools/translit';
import getLinkCurrentLang from '@/tools/getLinkCurrentLang';
import domReady from '@/tools/domReady';
import url from '@/tools/url';
import fetchJQueryAdapter from '@/tools/fetchJQueryAdapter';

export default {
  translit,
  url,
  domReady,
  getLinkCurrentLang,
  fetchJQueryAdapter
};
